import React from "react";
import { Container } from "./styles";
import Title from "../Title";
import { useBreakpoint } from "gatsby-plugin-breakpoints/BreakpointProvider";

const customer_logos_desktop = [
  "npr.svg",
  "american_life.svg",
  "gimlet.svg",
  "wall_street.svg",
  "story_corps.svg",
  "art_institvte.svg",
];

const customer_logos_mobile = [
  "npr.svg",
  "american_life.svg",
  "gimlet.svg",
  "story_corps.svg",
  "wall_street.svg",
  "art_institvte.svg",
  "anchor.svg",
];

const Customers = () => {
  const breakpoints = useBreakpoint();
  const logos = !breakpoints.md
    ? customer_logos_desktop
    : customer_logos_mobile;
  return (
    <Container>
      <Title title="Where to find us" />
      <div className="content">
        {logos.map((item, index) => (
          <img
            key={index}
            className="logo"
            src={require(`../../images/${item}`).default}
            alt="album-thumbnail"
          />
        ))}
      </div>
    </Container>
  );
};

export default Customers;
